import { render, staticRenderFns } from "./across_second.vue?vue&type=template&id=4565ac43&scoped=true"
import script from "./across_second.vue?vue&type=script&lang=js"
export * from "./across_second.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4565ac43",
  null
  
)

export default component.exports